var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"projets"},_vm._l((_vm.projects),function(project){return _c('Project',{key:project.id,ref:_vm.projects,refInFor:true,attrs:{"tags":project.tags,"backgroundColor":project.backgroundColor,"title":project.title,"description":project.description,"path":project.path,"imageAlt":project.alt}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }